import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";

import LovedOneList from "./LovedOneList/LovedOneList";
import AlertAction from "./AlertAction";
import DashBordAction from "../Dashboard/DashboardAction";
import { Modal } from "../CustomModal/Modal";
import { PATHS } from "./../../Constants";
import {
  OperationStatus,
  ALERTS_STATUS,
  APIResponse,
  SUMMARY_PARAM_NAMES,
  HttpStatus,
} from "../../Communication/Constants";
import { DEFAULT_PARAMETERS, PARAMETER_ID } from "./Constants";
import WakeUpAlert from "./WakeUpAlert/WakeUpAlert";
import StepsCount from "./StepsCount/StepsCount";
import CustomSpinner from "../Spinner/Spinner";

//css
import "./Alert.scss";
import "../../Resources/Styles/fonts.scss";

//reources
import { Strings } from "../../Resources/Strings/i18n";
import CommonUtils from "../../Utils/CommonUtils";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
//import ic_distance from "../../Resources/Images/ic_distance.png";
import ic_no_alerts from "../../Resources/Images/ic_no_alerts.png";
import img_app_store from "../../Resources/Images/img_app_store.png";
import img_google_play from "../../Resources/Images/img_google_play.png";

//material UI
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

class Alerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lovedOneModalOpen: false,
      selecteUser: undefined,
      hintAns: false,
      showErrorModal: false,
      errorMessage: "",
      showInstallAppModal: false,
      alertForSeletectedUser: undefined,
      custSpinner: false,
      dailyGoalError: false,

      wakeUpAlert1: {
        wakeupAlertId: undefined,
        isWakeupAlertActivated: false,
        defaultWakeupTime: DEFAULT_PARAMETERS.defaultWakeupTime,
        defaultWakeupNotifyTime: DEFAULT_PARAMETERS.defaultWakeupNotifyTime,
        isWakeupPhoneNotificationChecked: true,
        isWakeupTextMessageNotificationChecked: false,
        isWakeupEmailNotificationChecked: false,
      },
      stepsCountAlert1: {
        stepCountAlertId: undefined,
        isStepCountAlertActivated: false,
        defaultFootstepsEndTime: DEFAULT_PARAMETERS.defaultFootstepsEndTime,
        defaultFootstepsNotifyTime:
          DEFAULT_PARAMETERS.defaultFootstepsNotifyTime,
        stepCount: DEFAULT_PARAMETERS.stepCount,
        isStepCountNotificationChecked: true,
        isStepCountMessageNotificationChecked: false,
        isStepCountEmailNotificationChecked: false
      },

      wakeUpAlert: {
        checked: false,
        selectedDate: DEFAULT_PARAMETERS.defaultWakeupTime,
        notifyMe: DEFAULT_PARAMETERS.defaultWakeupNotifyTime,
        btnTurnOn: true,
      },
      stepsCountAlert: {
        checked: false,
        selectedDate: DEFAULT_PARAMETERS.defaultFootstepsEndTime,
        notifyMe: DEFAULT_PARAMETERS.defaultFootstepsNotifyTime,
        btnTurnOn: true,
        dailyGoal: DEFAULT_PARAMETERS.stepCount,
      },
    };
    this.AlertAction = new AlertAction();
    this.DashBordAction = new DashBordAction();
  }

  componentDidMount() {
    localStorage.removeItem("myState");
    this.retrievedState = JSON.parse(localStorage.getItem("selectedAlertId"));
    this.retrievedState && this.setState({selecteUser:this.retrievedState})
    if (
      this.props.inviteTokenInfo &&
      this.props.inviteTokenInfo.isInvitedUser
    ) {
      this.props.history.push("/home")
    }
    if ( this.props.userInfo && this.props.userInfo.id) {
      if (this.props.userList.monitored_users.length > 0) {
        this.getLovedOnes();
        this.getAlerts(this.retrievedState ? this.retrievedState.id : this.selectedLovedOne.id);
      }
    } else {
      this.setState({
        showErrorModal: true,
        errorMessage: Strings("ERROR_INVALID_AUTH_GRANT"),
      });
    }
  }

  getLovedOnes() {
    this.setState({ custSpinner: true });

    if (!this.props.userInfo.id) {
      this.setState({
        showErrorModal: true,
        errorMessage: Strings("ERROR_INVALID_AUTH_GRANT"),
        custSpinner: false,
        //"Session expired or error occurred, please login again!",
      });
    } else {
      //to get everytime updated data
      this.DashBordAction.getList(
        {
          userid: this.props.userInfo.id, //this.props.currentUserInfo.accessToken,
        },
        (listResponse) => {
          this.setState({ custSpinner: false });
        }
      );
    }
  }

  convert_date(time) {
    const time1 = time.split(":");
    const date = moment(new Date()).set({
      hour: parseInt(time1[0]),
      minute: parseInt(time1[1]),
    });
    return date;
  }

  createAlert(alert_object) {
    this.AlertAction.createAlert(alert_object, (actionCallback) => {
      if (actionCallback.status === OperationStatus.SUCCESS) {
        this.getAlerts(this.state.selecteUser.id);
      } //Error handling
      else if (
        actionCallback.error.errorCode === APIResponse.INVALID_USER_PROFILE
      ) {
        this.setState({
          errorMessage: actionCallback.error.errorMessage,
          showErrorModal: true,
        });
      } else if (
        actionCallback.error.errorCode === APIResponse.ALERTS_LIMIT_REACHED
      ) {
        this.setState({
          errorMessage: Strings("ALERTS_LIMIT_REACHED"),
          showErrorModal: true,
        });
      } else if (
        actionCallback.status === OperationStatus.NETWORK_NOT_REACHABLE
      ) {
        this.setState({
          errorMessage: actionCallback.error.errorMessage,
          showErrorModal: true,
        });
      } else {
        this.setState({
          errorMessage: actionCallback.error.errorMessage,
          showErrorModal: true,
        });
      }
    });
  }

  createWakeupTimeAlert = () => {
    let check_at_time = moment(
      this.state.wakeUpAlert1.defaultWakeupTime
    ).format("HH:mm");

    let notify_at_time = moment(
      this.state.wakeUpAlert1.defaultWakeupNotifyTime
    ).format("HH:mm");

    let alert_object = {
      alert_for_user: this.state.selecteUser && this.state.selecteUser.id,
      parameter: {
        id: PARAMETER_ID.FIRST_PHONE_USAGE,
        name: SUMMARY_PARAM_NAMES.wakeupTime,
      },
      alert: {
        check_at: check_at_time,
        notify_at: notify_at_time,
        check_at_timezone:
          this.state.selecteUser && this.state.selecteUser.timezone,
        notify_at_timezone: this.props.userInfo.timezone,
        op: "lt",
        value: null,
        notify_opts: {
          notify_by_push: this.state.wakeUpAlert1
            .isWakeupPhoneNotificationChecked,
          notify_by_sms: this.state.wakeUpAlert1
            .isWakeupTextMessageNotificationChecked,
          notify_by_email: this.state.wakeUpAlert1
            .isWakeupEmailNotificationChecked,
        },
      },
    };
    this.createAlert(alert_object);
  };

  createFootStepsAlert = () => {
    if (
      !this.state.stepsCountAlert1.stepCount ||
      this.state.stepsCountAlert1.stepCount === 0 ||
      this.state.stepsCountAlert1.stepCount < 0
    ) {
      this.setState({ dailyGoalError: true });
      return;
    }
    let check_at_time = moment(
      this.state.stepsCountAlert1.defaultFootstepsEndTime
    ).format("HH:mm");

    let notify_at_time = moment(
      this.state.stepsCountAlert1.defaultFootstepsNotifyTime
    ).format("HH:mm");
    //if steps count entered by user is less than zero then

    if (
      !this.state.stepsCountAlert1.stepCount ||
      this.state.stepsCountAlert1.stepCount <= 0
    ) {
      return;
    }
    let alert_object = {
      alert_for_user: this.state.selecteUser && this.state.selecteUser.id,
      parameter: {
        id: PARAMETER_ID.FOOTSTEPS,
        name: SUMMARY_PARAM_NAMES.Footsteps,
      },
      alert: {
        check_at: check_at_time,
        notify_at: notify_at_time,
        check_at_timezone:
          this.state.selecteUser && this.state.selecteUser.timezone,
        notify_at_timezone: this.props.userInfo.timezone,
        op: "lt",
        value: this.state.stepsCountAlert1.stepCount,
        notify_opts: {
          notify_by_push: this.state.stepsCountAlert1
            .isStepCountNotificationChecked,
          notify_by_sms: this.state.stepsCountAlert1
            .isStepCountMessageNotificationChecked,
          notify_by_email: this.state.stepsCountAlert1
            .isStepCountEmailNotificationChecked,
        },
      },
    };

    this.createAlert(alert_object);
  };

  getAlerts(id = this.selectedLovedOne.id) {
    //no alerts for particular loved one
    this.setState({
      custSpinner: true,
      wakeUpAlert1: {
        ...this.state.wakeUpAlert1,
        wakeupAlertId: undefined,
        isWakeupAlertActivated: false,
        defaultWakeupTime: DEFAULT_PARAMETERS.defaultWakeupTime,
        defaultWakeupNotifyTime: DEFAULT_PARAMETERS.defaultWakeupNotifyTime,
        isWakeupPhoneNotificationChecked: true,
        isWakeupTextMessageNotificationChecked: false,
        isWakeupEmailNotificationChecked: false,
      },
      stepsCountAlert1: {
        ...this.state.stepsCountAlert1,
        stepCountAlertId: undefined,
        isStepCountAlertActivated: false,
        defaultFootstepsEndTime: DEFAULT_PARAMETERS.defaultFootstepsEndTime,
        defaultFootstepsNotifyTime:
          DEFAULT_PARAMETERS.defaultFootstepsNotifyTime,
        stepCount: DEFAULT_PARAMETERS.stepCount,
        isStepCountNotificationChecked: true,
        isStepCountMessageNotificationChecked: false,
        isStepCountEmailNotificationChecked: false,
      },
    });

    if (this.props.userList.monitored_users.length) {
      this.AlertAction.getAlerts(
        {
          userid: id, //this.props.currentUserInfo.accessToken,
        },
        (listResponse) => {
          if (listResponse.status === OperationStatus.SUCCESS) {
            this.setState({ custSpinner: false });
            if (listResponse.data != null && listResponse.data.data != null) {
              let alertObject = listResponse.data.data;
              this.setState({ alertForSeletectedUser: alertObject });
              // this.props.setAlertsStatus(
              //   alertObject.alerts != null && alertObject.alerts.length > 0
              // );
              if (alertObject.alerts != null && alertObject.alerts.length > 0) {
                for (let i = 0; i < alertObject.alerts.length; i++) {
                  let alert = alertObject.alerts[i];

                  if (alert.parameter_id === PARAMETER_ID.FIRST_PHONE_USAGE) {
                    this.setState({
                      ...this.state,
                      wakeUpAlert1: {
                        ...this.state.wakeUpAlert1,
                        wakeupAlertId: alert.id,
                        isWakeupAlertActivated:
                          alert.status === ALERTS_STATUS.ACTIVE,
                        defaultWakeupTime: this.convert_date(
                          alert.alert_data.check_at_local
                        ),
                        defaultWakeupNotifyTime: this.convert_date(
                          alert.alert_data.notify_at_local
                        ),
                        isWakeupPhoneNotificationChecked:
                          alert.notification_options.notify_by_push,
                        isWakeupTextMessageNotificationChecked:
                          alert.notification_options.notify_by_sms,
                        isWakeupEmailNotificationChecked:
                          alert.notification_options.notify_by_email,
                      },
                    });
                  }
                  if (alert.parameter_id === PARAMETER_ID.FOOTSTEPS) {
                    // this.stepCountRef.setValue(alert.alert_data.value);
                    this.setState({
                      ...this.state,
                      stepsCountAlert1: {
                        ...this.state.stepsCountAlert1,
                        stepCountAlertId: alert.id,
                        isStepCountAlertActivated:
                          alert.status === ALERTS_STATUS.ACTIVE,
                        defaultFootstepsEndTime: this.convert_date(
                          alert.alert_data.check_at_local
                        ),
                        defaultFootstepsNotifyTime: this.convert_date(
                          alert.alert_data.notify_at_local
                        ),
                        stepCount: alert.alert_data.value,
                        isStepCountNotificationChecked:
                          alert.notification_options.notify_by_push,
                        isStepCountMessageNotificationChecked:
                          alert.notification_options.notify_by_sms,
                        isStepCountEmailNotificationChecked: 
                          alert.notification_options.notify_by_email,
                      },
                    });
                  }
                }
              }
            } else {
              this.setState({
                wakeUpAlert1: {
                  ...this.state.wakeUpAlert1,
                  isWakeupAlertActivated: false,
                },
                stepsCountAlert1: {
                  ...this.state.stepsCountAlert1,
                  isStepCountAlertActivated: false,
                },
              });
            }
          } else {
            this.setState({
              custSpinner: false,
              showErrorModal: true,
              errorMessage: listResponse.error.errorMessage,
            });
          }
        }
      );
    }
  }

  deleteAlert = (alert_id, parameter_id) => {
    this.setState({ custSpinner: true });
    this.AlertAction.deleteAlert(alert_id, (actionCallback) => {
      this.setState({ custSpinner: false });
      if (actionCallback.status === OperationStatus.SUCCESS) {
        this.getAlerts(this.state.selecteUser.id);
        //reset values depending on parameter id
        if (parameter_id == PARAMETER_ID.FIRST_PHONE_USAGE) {
          this.setState({
            wakeUpAlert1: {
              ...this.state.wakeUpAlert1,
              wakeupAlertId: undefined,
              isWakeupAlertActivated: false,
              defaultWakeupTime: DEFAULT_PARAMETERS.defaultWakeupTime,
              defaultWakeupNotifyTime:
                DEFAULT_PARAMETERS.defaultWakeupNotifyTime,
              isWakeupPhoneNotificationChecked: true,
              isWakeupTextMessageNotificationChecked: false,
              isWakeupEmailNotificationChecked: false,
            },
          });
        }
        if (parameter_id == PARAMETER_ID.FOOTSTEPS) {
          this.setState({
            stepsCountAlert1: {
              ...this.state.stepsCountAlert1,
              stepCountAlertId: undefined,
              isStepCountAlertActivated: false,
              defaultFootstepsEndTime:
                DEFAULT_PARAMETERS.defaultFootstepsEndTime,
              defaultFootstepsNotifyTime:
                DEFAULT_PARAMETERS.defaultFootstepsNotifyTime,
              stepCount: DEFAULT_PARAMETERS.stepCount,
              isStepCountNotificationChecked: true,
              isStepCountMessageNotificationChecked: false,
              isStepCountEmailNotificationChecked: false,
            },
          });
        }
      } //Error handling
      else {
        if (
          actionCallback.error.errorCode == HttpStatus.UNAUTHORIZED ||
          actionCallback.error.errorCode == APIResponse.INVALID_AUTH_GRANT
        ) {
          this.setState({
            errorMessage: actionCallback.error.errorMessage,
            showErrorModal: true,
          });
        } else {
          this.setState({
            errorMessage: actionCallback.error.errorMessage,
            showErrorModal: true,
          });
        }
      }
    });
  };

  hideModal = () => {
    this.setState({
      showInstallAppModal: false,
    });
  };
  render() {
    const monitored_users = this.props.userList.monitored_users || [];
    this.selectedLovedOne = this.state.selecteUser || monitored_users[0];
    if (!this.state.selecteUser && monitored_users[0]) {
      this.setState({
        selecteUser: monitored_users[0],
      });
    }
    let alertsUsedText = Strings("DefaultAlertsUsedMessage");

    if (this.state.alertForSeletectedUser !== undefined) {
      let currentAlert =
        this.state.selecteUser.id === this.props.userInfo.id
          ? this.state.alertForSeletectedUser.alert_for_self_info
              .self_alert_count
          : this.state.alertForSeletectedUser.alerts.length;
      let allowedAlert =
        this.state.selecteUser.id === this.props.userInfo.id
          ? this.state.alertForSeletectedUser.alert_for_self_info
              .allowed_self_alerts_count
          : this.state.alertForSeletectedUser.allowed_alerts_count;

      alertsUsedText =
        "You have used " + currentAlert + " / " + allowedAlert + " Alerts";
    }

    return (
      <div className="Alert">
        <CustomSpinner showModal={this.state.custSpinner} />
        {/* show Install App modal */}
        <div>
          {this.state.showInstallAppModal ? (
            <Modal
              show={this.state.showInstallAppModal}
              handleClose={this.hideModal}
              parent={"login"}
            >
              {
                <div className="appInstallModal">
                  <div className="errorOtp">
                    <div className="errorModal">
                      <div className="modalTitle">
                        <p id="errorTitle">
                          <span id="errorText">{Strings("InstallApp")}</span>
                        </p>
                      </div>
                      <div className="errorContainer">
                        <div className="errorContent">
                          <p>{Strings("InstallAppInfo")}</p>
                          <div>
                            <a
                              // href="https://allwellapp.com/"
                              onClick={() => {
                                window.open(
                                  "https://allwellapp.com/free",
                                  "_self"
                                );
                                setTimeout(() => {
                                  this.setState({
                                    showInstallAppModal: false,
                                  });
                                }, 100);
                              }}
                            >
                              <img
                                src={img_google_play}
                                alt={img_google_play}
                              />
                            </a>
                            <a
                              //href="https://allwellapp.com/"
                              onClick={() => {
                                window.open(
                                  "https://allwellapp.com/free",
                                  "_self"
                                );
                                setTimeout(() => {
                                  this.setState({
                                    showInstallAppModal: false,
                                  });
                                }, 100);
                              }}
                            >
                              <img src={img_app_store} alt={img_app_store} />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </Modal>
          ) : null}
        </div>

        {/* error modal */}
        <div>
          {this.state.showErrorModal ? (
            <Modal
              show={this.state.showErrorModal}
              // handleClose={this.hideModal}
              parent={"exitsession"}
            >
              {
                <div>
                  <div className="errorOtp">
                    <div className="errorModal">
                      <div className="modalTitle">
                        <p id="errorTitle">
                          <span id="errorText">{Strings("Error")}</span>
                          {Strings("ErrorOccurred")}
                        </p>
                      </div>
                      <div className="errorContainer">
                        <div className="errorContent">
                          <p>{this.state.errorMessage}</p>
                        </div>
                      </div>
                      <Button
                        className="errorBtn"
                        onClick={() => {
                          this.setState(
                            {
                              showErrorModal: false,
                            },
                            () => {
                              !this.props.userInfo.id
                                ? this.props.history.push(PATHS.LOGIN)
                                : this.props.history.push();
                            }
                          );
                        }}
                      >
                        {this.state.errorMessage ===
                        String("ERROR_INVALID_AUTH_GRANT")
                          ? Strings("CloseAndLogin")
                          : Strings("Close")}
                      </Button>
                    </div>
                  </div>
                </div>
              }
            </Modal>
          ) : null}
        </div>

        {monitored_users.length === 0 ? (
          <div className="emptyDataAlerts">
            <div className="emptyDataAlertImg">
              <img src={ic_no_alerts} alt={ic_no_alerts} />
            </div>
            <div className="emptyDataAlertText1">{Strings("SetAlerts")}</div>
            <div className="emptyDataAlertText2">
              {Strings("emptySetAlert")}
            </div>
            <div className="emptyDataAlertText3">
              {Strings("InviteOrConnect")}
            </div>
            <div className="emptyDataAlertText4">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={() => this.props.history.push(PATHS.CARECIRCLE)}
              >
                {Strings("MyCareCircleTitle")}
              </Button>
            </div>
          </div>
        ) : (
          <div className="AlertsContent">
            {this.state.alertForSeletectedUser !== undefined &&
            this.state.alertForSeletectedUser.allowed_alerts_count ===
              "unlimited" ? null : (
              <div className="alertsCount">
                <div className="alertCountText">{alertsUsedText}</div>
                <div className="upgradeBtn">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    onClick={() => this.setState({ showInstallAppModal: true })}
                  >
                    {Strings("Upgrade")}
                  </Button>
                </div>
              </div>
            )}
            <div className="lovedOneList">
              <ArrowDropDownIcon
                onClick={() =>
                  this.setState((state) => ({
                    lovedOneModalOpen: !state.lovedOneModalOpen,
                  }))
                }
              />
              <Accordion
                expanded={this.state.lovedOneModalOpen}
                onClick={() =>
                  this.setState((state) => ({
                    lovedOneModalOpen: !state.lovedOneModalOpen,
                  }))
                }
              >
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <LovedOneList lovedOnes={this.selectedLovedOne} />
                </AccordionSummary>
                {monitored_users.map((name, index) => {
                  return (
                    <AccordionSummary
                      className={
                        this.selectedLovedOne.id === name.id ? "selected" : ""
                      }
                      key={name.id}
                      onClick={() => {
                        this.setState((state) => ({
                          selecteUser: name,
                        }));
                        this.getAlerts(name.id);
                      }}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <LovedOneList lovedOnes={name} />
                    </AccordionSummary>
                  );
                })}
              </Accordion>
            </div>

            <div className="allAlerts">
              <WakeUpAlert
                selecteUser={this.state.selecteUser}
                wakeUpAlertData={this.state.wakeUpAlert1}
                wakeUpTime={(date) =>
                  this.setState({
                    wakeUpAlert1: {
                      ...this.state.wakeUpAlert1,
                      defaultWakeupTime: date,
                    },
                  })
                }
                wakeUpNotifyMeTime={(date) =>
                  this.setState({
                    wakeUpAlert1: {
                      ...this.state.wakeUpAlert1,
                      defaultWakeupNotifyTime: date,
                    },
                  })
                }
                userInfo={this.props.userInfo}
                textNotificationStatus={(status) =>
                  this.setState({
                    wakeUpAlert1: {
                      ...this.state.wakeUpAlert1,
                      isWakeupTextMessageNotificationChecked: status,
                    },
                  })
                }
                emailNotificationStatus={(status) =>
                  this.setState({
                    wakeUpAlert1: {
                      ...this.state.wakeUpAlert1,
                      isWakeupEmailNotificationChecked: status,
                    },
                  })
                }
                showInstallApp={(value) =>
                  this.setState({ showInstallAppModal: value })
                }
                createWakeupTimeAlert1={this.createWakeupTimeAlert}
                deleteAlert1={this.deleteAlert}
              />
              <StepsCount
                selecteUser={this.state.selecteUser}
                stepsCountAlertData={this.state.stepsCountAlert1}
                hintAns={this.state.hintAns}
                stepsCountEndTime={(date) => {
                  this.setState({
                    stepsCountAlert1: {
                      ...this.state.stepsCountAlert1,
                      defaultFootstepsEndTime: date,
                    },
                  });
                }}
                stepsCountNotifyMeTime={(date) =>
                  this.setState({
                    stepsCountAlert1: {
                      ...this.state.stepsCountAlert1,
                      defaultFootstepsNotifyTime: date,
                    },
                  })
                }
                showHintText={(value) => this.setState({ hintAns: value })}
                userInfo={this.props.userInfo}
                textNotificationStatus={(status) =>
                  this.setState({
                    stepsCountAlert1: {
                      ...this.state.stepsCountAlert1,
                      isStepCountMessageNotificationChecked: status,
                    },
                  })
                }
                emailNotificationStatus={(status) =>
                  this.setState({
                    stepsCountAlert1: {
                      ...this.state.stepsCountAlert1,
                      isStepCountEmailNotificationChecked: status,
                    },
                  })
                }
                dailyGoalSteps={(value) =>
                  this.setState({
                    dailyGoalError: false,
                    stepsCountAlert1: {
                      ...this.state.stepsCountAlert1,
                      stepCount: value,
                    },
                  })
                }
                showInstallApp={(value) =>
                  this.setState({ showInstallAppModal: value })
                }
                createFootStepsAlert1={this.createFootStepsAlert}
                dailyGoalError={this.state.dailyGoalError}
                deleteAlert1={this.deleteAlert}
              />
            </div>
          </div>
        )}

        <Snackbar
          open={this.state.hintAns}
          autoHideDuration={1000}
          onClose={() => {}}
          className="hintAnswer"
        >
          <MuiAlert onClose={() => {}} severity="success">
            {Strings("DailyToastMessageText")}
          </MuiAlert>
        </Snackbar>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: CommonUtils.getInvitedTokenInfo(state),
    userList: state.Dashboard.userInfo,
    data: state.CareCircle.data,
    error: state.CareCircle.error,
    alertsData: state.Alert.alertsData,
    invitedUserInfo: state.Dashboard.invitedUserInfo,
    inviteTokenInfo: state.InvitationHandler.accessInfo,
  };
};

export default connect(mapStateToProps)(Alerts);
